import React from 'react';
import { useForm } from 'react-hook-form';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const { register, handleSubmit } = useForm();
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    const res = await login(data.email, data.password);
    if (res.success) {
      navigate('/admin');
    } else {
      alert(res.message || 'Login failed');
    }
  };

  return (
    <div className="container" style={{ padding: '2rem' }}>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: 400 }}>
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label>Email</label>
          <input type="email" className="form-control" {...register('email', { required: true })} />
        </div>
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label>Password</label>
          <input type="password" className="form-control" {...register('password', { required: true })} />
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button type="submit" className="btn btn-primary">Login</button>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="btn btn-secondary"
          >
            Home
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;


